import { Input, Modal, ModalBody } from "reactstrap"
import PrimaryButton from "../../../../../../components/common/PrimaryButton/PrimaryButton"
import styles from "./ChangePasswordModal.module.scss"

const ChangePasswordModal = ({ isModalOpen, setIsModalOpen }) => {
  const toggle = () => setIsModalOpen(!isModalOpen)

  return (
    <div>
      <Modal
        isOpen={isModalOpen}
        toggle={toggle}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minHeight: "484px",
          minWidth: "430px",
          maxWidth: "460px",
        }}
      >
        <ModalBody>
          <div className="text-center">
            <div className="my-3 fw-medium fs-4">Change Password</div>
          </div>

          <div className="d-flex flex-column gap-3">
            <div>
              <div className={styles.label}>Current Password</div>
              <div>
                <Input placeholder="Enter Old Password" />
              </div>
            </div>

            <div className={styles.para}>Password must be at least 8 characters including upper and lower case letters, numbers, and special characters.</div>

            <div>
              <div className={styles.label}>New Password</div>
              <div>
                <Input placeholder="Enter New Password" />
              </div>
            </div>

            <div>
              <div className={styles.label}>Confirm Password</div>
              <div>
                <Input placeholder="Enter new Password to Confirm" />
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <span className={styles.forgetPassword}>Forget Password?</span>
            <PrimaryButton name="Save New Password" />
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default ChangePasswordModal
